import React from 'react'
// import ReactDOM from 'react-dom';
import { API, graphqlOperation } from 'aws-amplify'
// import { connect } from 'react-redux'
// import classnames from "classnames";
// import { onCreateReqHistory } from './../../graphql/subscriptions'
import { createResource } from '../graphql/mutations'

import { 
    Card,
    CardHeader,
    CardTitle,
    CardBody,
    Row,
    Container,
    Button,
    Input,
    Col,
    Collapse
} from "reactstrap";


class NewSQSForm extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            launchTemplateid: '',
            name: '',
            visTimeout: '',
            maxAttempts: '',
        }
        
    }

    handleNameChange = event => {
        this.setState({name: event.target.value})
        // console.log(event.target.value)
    }

    handleMaxAttemptsChange = event => {
        this.setState({maxAttempts: event.target.value})
        // console.log(event.target.value)
    }

    handlevisTimeoutChange = event => {
        this.setState({visTimeout: event.target.value})
        // console.log(event.target.value)
    }

    onButtonClick = async() => {

        const values = {
            name: this.state.name,
            status: 'New',
            type: 'SQS',
            subtype: 'Primary',
            sqsurl: '',
            sqsdeadLetterurl: '',
            sqsmaxAttempts: this.state.maxAttempts,
            sqsVisibilityTimeout: this.state.visTimeout,
        }
        console.log(values)
        const response = await API.graphql(graphqlOperation(createResource, {input: values}))
        console.log(response)
    }

    render() {
        return(
            <>
                <Container>
                    <Row>
                        <Col>
                            <Input placeholder="Name" required="true" type="text" value={this.state.name} onChange={this.handleNameChange} /> 
                        </Col>
                        <Col>
                            <Input placeholder="Max Attempts" required="true" type="number" value={this.state.maxAttempts} onChange={this.handleMaxAttemptsChange} /> 
                        </Col>
                        <Col>
                            <Input placeholder="Visibility Timeout (Seconds)" required="true" type="number" value={this.state.visTimeout} onChange={this.handlevisTimeoutChange} /> 
                        </Col>
                        <Col>
                            <Button className="btn btn-outline-danger" onClick={ e => this.onButtonClick(  ) }>Submit</Button>
                        </Col>
                    </Row>
                </Container>
            </>
        )
    }
}


export default NewSQSForm



